import { ResourceProps } from "react-admin";
import { ReferralsShow, ReferralUsersList } from "./components";

export const referralUsersResource: Omit<ResourceProps, "name"> = {
  list: ReferralUsersList,
  show: ReferralsShow,
};
